import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import estimateField from "../../../../../service/estimateFields/estimateField"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./planBgacsp.png"

const BGA_CSP = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { planBgacsp: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="BGA／CSP" src={img} helpURL={HELP_LINKS["BGA／CSP"]}>
      <RadioGroup name={estimateField.planBgacsp.key} selectedValue={values.planBgacsp} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["BGA／CSP"].あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT["BGA／CSP"].なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.planBgacsp} />
    </OneClickField>
  )
}

export default BGA_CSP
